import React, { useState } from "react";
import logo from "../images/logo.png";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import styles from "./header.module.css";

const Header = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showComponent, setShowComponent] = useState(false);
  const [noComponentFound, setNoComponentFound] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchQuery.trim() === "") {
      setSearchQuery("");
      setShowComponent(false);
      setNoComponentFound(false);
      navigate("/");
    } else {
      setShowComponent(true);
      setNoComponentFound(false);
      if (searchQuery.toLowerCase() === "bed") {
        navigate("/home-furniture/bed");
      } else if (searchQuery.toLowerCase() === "wardrobe") {
        navigate("/home-furniture/wardrobe");
      } else if (searchQuery.toLowerCase() === "study table") {
        navigate("/home-furniture/study-table");
      } else if (searchQuery.toLowerCase() === "sofa") {
        navigate("/home-furniture/sofa");
      } else if (searchQuery.toLowerCase() === "washing machine") {
        navigate("/home-appliances/washing-machine");
      } else if (searchQuery.toLowerCase() === "fridge") {
        navigate("/home-appliances/fridge");
      } else {
        setNoComponentFound(true);
      }
    }
  };

  const handleInput = (event) => {
    setSearchQuery(event.target.value);
    if (event.target.value.trim() === "") {
      setShowComponent(false);
      setNoComponentFound(false);
      navigate("/");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <img src={logo} alt="Logo" />
      </div>
      <nav className={styles.nav}>
        <Link to="/home-furniture">Home Furniture</Link>
        <Link to="/home-appliances">Home Appliances</Link>
        <Link to="/about">About Us</Link>
        <Link to="/trending-product">Trending Furniture</Link>
      </nav>
      <div className={styles.searchBar}>
        <input
          type="text"
          value={searchQuery}
          onInput={handleInput}
          onKeyPress={handleKeyPress}
          placeholder="What are you looking for?"
        />
        <button onClick={handleSearch}>Search</button>
      </div>
      {noComponentFound && (
        <div className={styles.noComponentFound}>
          No Data found for '{searchQuery}'
        </div>
      )}
    </header>
  );
};
export default Header;
